import React from 'react';
import { useEffect, useState } from "react";
import { Field } from "redux-form";
import {
  FormGroup,
  Transition,
  Header,
  Divider,
  Popup,
  Button,
} from "semantic-ui-react";
import { TextInput, CheckboxInput } from "../../utils/form-fields";
import { ColorPicker } from "../../utils/helpers";
import Loading from "../../../app/loading";

const ValueTileTab = ({ banner, template, change }) => {
  const [showVt, setShowVt] = useState(false);

  useEffect(() => {
    if (banner) {
      if (banner.fields) {
        let showValue = banner.fields.IncludeValueTile;
        if (showValue === "yes") showValue = true;
        if (showValue === "no") showValue = false;
        setShowVt(showValue);
      }
    }
  }, [banner]);

  if (!banner) return <Loading />;

  return (
    <>
      <Field
        component={CheckboxInput}
        name={`fields.IncludeValueTile`}
        label="Include value tile"
        type="checkbox"
      />
      <Divider hidden />
      <Transition visible={showVt} animation="slide down" duration={200}>
        <div>
          <FormGroup>
            <Field
              component={CheckboxInput}
              name={`fields.AddClubcardPrice`}
              label="Add Clubcard Price"
              type="checkbox"
            />
            <Field
              component={TextInput}
              name={`fields.ValueTileTop`}
              label="Value Tile Text Top"
              type="text"
            />
            <Field
              component={TextInput}
              name={`fields.ValueTileTopFontSize`}
              label="Font size"
              type="text"
            />
            <Field
              component={TextInput}
              name={`fields.ValueTileBottom`}
              label="Value Tile Text Bottom"
              type="text"
              placeholder="Use this for a second line"
            />
            <Field
              component={TextInput}
              name={`fields.ValueTileBottomFontSize`}
              label="Font size"
              type="text"
            />
          </FormGroup>
          <Divider hidden />
          <FormGroup>
            <Field
              component={CheckboxInput}
              name={`fields.AddRegularPrice`}
              label="Add Regular Price"
              type="checkbox"
            />
            <Field
              component={TextInput}
              name={`fields.RegularPrice`}
              label="Regular Price"
              type="text"
            />
          </FormGroup>
        </div>
      </Transition>
      <Header as="h3">Call To Action options</Header>
      <FormGroup>
        <Field
          label="CTA Colour"
          name={`fields.CTAColour`}
          type="text"
          component={TextInput}
        >
          <ColorPicker
            presetColors={template.colorPresets}
            color={banner.fields.CTAColour}
            colorPickerType="rgb"
            onSelect={(col) => {
              change(`fields.CTAColour`, col);
            }}
          />
        </Field>
        <div className="field popup">
          <Popup
            content="Must be in the format of R G B. If you have a hex value, enter it into hex field in the colour picker popup."
            trigger={<Button icon="question" />}
          />
        </div>
        <Field
          label="Arrow Colour"
          name={`fields.CTAArrowColour`}
          type="text"
          component={TextInput}
        >
          <ColorPicker
            presetColors={template.colorPresets}
            color={banner.fields.CTAArrowColour}
            colorPickerType="nohex"
            onSelect={(col) => {
              change(`fields.CTAArrowColour`, col);
            }}
          />
        </Field>
        <div className="field popup">
          <Popup
            content="Hex value without the # (remove it if you manually enter a value)"
            trigger={<Button icon="question" />}
          />
        </div>
      </FormGroup>
    </>
  );
};

export default ValueTileTab;
